import { Article } from "@faire/help-center-utils/articles";
import { useMemo } from "react";

import { useLoggedOutContactUsContextStore } from "./LoggedOutContactUsContextStore";
import { ISSUE_TO_ARTICLE } from "./types";
import { useBrandArticlesByNode } from "./useBrandArticlesByNode";
import { useLoggedOutUserType } from "./useLoggedOutUserType";
import { useRetailerArticlesByNode } from "./useRetailerArticlesByNode";

type LoggedOutHelpCenterArticle = {
  helpCenterArticles: Article[];
};

export const useLoggedOutHelpCenterArticle = (): LoggedOutHelpCenterArticle => {
  const { isRetailer } = useLoggedOutUserType();
  const [{ issueL1, issueL2, issueL3 }] = useLoggedOutContactUsContextStore([
    "issueL1",
    "issueL2",
    "issueL3",
  ]);
  const { retailerArticlesByNode } = useRetailerArticlesByNode();
  const { brandArticlesByNode } = useBrandArticlesByNode();

  const helpCenterArticles = useMemo(() => {
    if (isRetailer) {
      if (issueL1) {
        const retailerArticlesByIssueL1 = retailerArticlesByNode[
          issueL1
        ] as ISSUE_TO_ARTICLE;

        if (issueL2) {
          const retailerArticlesByIssueL2 =
            retailerArticlesByIssueL1[issueL2 as keyof ISSUE_TO_ARTICLE];

          if (issueL3) {
            const retailerArticlesByIssueL3 = (
              retailerArticlesByIssueL2 as ISSUE_TO_ARTICLE
            )[issueL3];

            return retailerArticlesByIssueL3 as Article[];
          }
          return retailerArticlesByIssueL2 as Article[];
        }
        return retailerArticlesByNode[issueL1] as Article[];
      }
    } else {
      if (issueL1) {
        const brandArticlesByIssueL1 = brandArticlesByNode[
          issueL1
        ] as ISSUE_TO_ARTICLE;
        if (issueL2) {
          const brandArticlesByIssueL2 =
            brandArticlesByIssueL1[issueL2 as keyof ISSUE_TO_ARTICLE];
          if (issueL3) {
            const brandArticlesByIssueL3 = (
              brandArticlesByIssueL2 as ISSUE_TO_ARTICLE
            )[issueL3];
            return brandArticlesByIssueL3 as Article[];
          }
          return brandArticlesByIssueL2 as Article[];
        }
        return brandArticlesByNode[issueL1] as Article[];
      }
    }
    return [];
  }, [
    brandArticlesByNode,
    isRetailer,
    issueL1,
    issueL2,
    issueL3,
    retailerArticlesByNode,
  ]);

  return {
    helpCenterArticles,
  };
};
